<template>
  <!-- 卡片列表 -->
  <div v-loading="loading"
       v-infinite-scroll="load">

    <div class="card-one-list-items"
         v-for="(o, index) in itemList"
         :key="index">
      <el-card shadow="hover"
               :body-style="{ padding: '0px' }">

        <!-- 辅助 -->
        <!-- <div>{{checked_list}}</div> -->
        <!-- item -->
        <div class="card-item">
          <div>
            <!-- 图片 【可以点击】 -->
            <img class="image_cover"
                 :style="imageSize"
                 @click="clickCard(o)"
                 :src="o.image" />
            <!-- 迹点分类 -->
          </div>
          <!-- 文字 -->
          <div class="content_text">
            <!-- 产品标题【可以点击】:有2行，超过之后用... 显示 -->
            <div class="card-text-title"
                 @click="clickCard(o)">
              <h5>
                {{ o.title }}
              </h5>
            </div>
            <!-- 下标题 -->
            <div class="under-title"
                 v-if="showMiniTitle">
              <!-- 下标题名称 -->
              <span v-if="o.title_mini"
                    style="font-size: 5px;">{{titleMiniName}}</span>
              <!-- 下标题内容：简介 -->
              <span v-html="o.title_mini.length > 10 ? o.title_mini.slice(0, 10) + '...' :o.title_mini">
              </span>
            </div>
            <!-- 标签 -->
            <div v-if="showTag">
              <span style="font-size: 13px">标签:</span>
              <el-tag style="margin-left: 5px"
                      v-for="(tag_item, index) in o.tag"
                      :key="index"
                      size="mini"
                      type="">
                {{tag_item.tag_name}}
              </el-tag>
            </div>
            <!-- 目的地 -->
            <div v-if="showDest">
              <span style="font-size: 13px">目的地:</span>
              <el-tag style="margin-left: 5px"
                      v-for="(locitem) in o.dest"
                      :key="locitem.id"
                      size="mini"
                      type="info">{{ locitem }}</el-tag>
            </div>
            <!-- 更新/选择 -->
            <div class="content-text-bottom-item">
              <!-- 更新于日期 -->
              <div v-if="showUpdate"
                   class="time">更新于: {{ o.update_time }}</div>
              <!-- 迹点分类 -->
              <div class="traver_class_card_one_list_style"
                   v-if="o.class_name!==''">
                {{o.class_name}}
              </div>
              <!-- 添加按钮 -->
              <el-button v-if="checked_list.indexOf(o.id)>-1"
                         class="content-text-bottom-button"
                         @click="checkedItem(o)"
                         style="color:green"
                         icon="el-icon-success"
                         type="text">{{buttonName}}</el-button>
              <!-- 已选按钮 -->
              <el-button v-else
                         @click="checkedItem(o)"
                         type="text"
                         class="content-text-bottom-button"
                         icon="el-icon-circle-plus">
              </el-button>
            </div>
          </div>
          <!-- 文字结束 -->
        </div>
      </el-card>

    </div>
    <!-- <div v-if="noMoreData"
         style="text-align:center;width: 100%; background-color:red;cursor: pointer;"
         @click="loadMorTraverPointer">加载更多{{itemList.length}}</div> -->
    <!-- 却一个时候填充的模块 -->

  </div>
</template>

<script>
export default {
  name: 'card-check-list',
  data() {
    return {
      imageSize: `height: ${this.imageHeight}px; width: ${this.imageWidth}px;`,
      loading: false,
      itemList: this.cardList,
      // 已选列表
      checked_list: this.checkedList,
      //
      page_no: 1,
      noMoreData: true,
    }
  },
  watch: {
    cardList(val) {
      this.itemList = val
    },
    checkedList(val) {
      this.checked_list = val
    },
  },
  props: {
    checkedList: {
      type: Array,
      default: () => {
        return []
      },
    },
    cardList: {
      type: Array,
      default: () => {
        return []
      },
    },
    titleMiniName: {
      type: String,
      default: '下标题名称:',
    },
    showMiniTitle: {
      type: Boolean,
      default: true,
    },
    // 显示功能区
    showTitleImage: {
      type: Boolean,
      default: true,
    },
    buttonName: {
      type: String,
      default: '按钮',
    },
    showDest: {
      type: Boolean,
      default: true,
    },
    showTag: {
      type: Boolean,
      default: true,
    },
    showUpdate: {
      type: Boolean,
      default: true,
    },
    // 图片设置  147 *235
    imageHeight: {
      type: Number,
      default: 69.8,
    },
    imageWidth: {
      type: Number,
      default: 114,
    },
  },
  methods: {
    load() {
      console.log('cardOneList翻页')
      this.page_no += 1
      this.$emit('loadMorTraverPointer', this.page_no)
    },
    clickCard(val) {
      // console.log(val)
      this.$emit('clickTraverPoint', val)
    },
    // loadMorTraverPointer() {
    //   this.page_no += 1
    //   this.$emit('loadMorTraverPointer', this.page_no)
    // },
    checkedItem(value) {
      // 判断点击的item 的id 在不在列表中
      let arrItemIndex = this.checked_list.indexOf(value.id)
      if (arrItemIndex > -1) {
        // 如果在，就把这个id 移除
        console.log('执行取消选择')
        this.checked_list.splice(arrItemIndex, 1)
        // 【编辑日行程时使用】
        this.$emit('checkOneItemToDayTrip', value.id)
      } else {
        // 如果不在，就把这个id 添加进去
        // console.log('执行选择')
        this.checked_list.push(value.id)
        setTimeout(() => {
          this.$emit('checkOneItemToDayTrip', value.id)
        }, 1000)
      }

      // 【作为绑定内容选择列表时使用】
      this.$emit('checkedItem', this.checked_list)
    },
  },
}
</script>

<style scoped>
/* 基本 */
.image_cover {
  display: block;
  cursor: pointer;
  width: 100%;
}

/* 卡片 */
.card-item-one-list {
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  justify-content: space-between;
  /* align-items: flex-start; */
  align-content: flex-start;
}
.card-one-list-items {
  width: 100%;
  margin-bottom: 5px;
  /* cursor 光标属性，可以添加click事件 */
}

/* 单个卡片样式 */
.card-item {
  display: flex;
  position: relative;
  width: 100%;
  /* justify-content: space-between; */
}

.content_text {
  width: 100%;
  margin: 3px;
}
.card-text-title {
  font-size: 14px;
  margin-left: 3px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.content-text-bottom-item {
  display: flex;
  /* margin-top: 5px; */
  justify-content: space-between;
}

.content-text-bottom-button {
  font-size: 15px;
  padding: 0;
  /* width: 100%; */
  /* float: right; */
  margin-left: auto;
  /* text-align: right; */
}
.traver_class_card_one_list_style {
  background-color: #ff5421;
  padding: 0 10px;
  color: #fff;
  font-size: 10px;
}

.under-title {
  color: grey;
  height: 25px;
  margin-left: 3px;
}
</style>